module.exports = __webpack_public_path__ + "images/file_icons_v2/log-b822d164df0a42ed6079c157e745327e.svg";